import * as ORDER_END_POINTS from "../constants/endpoints/order";
import axios from "../axios/axios";

export const getPreviousOrders = () => {
  return axios({
    url: ORDER_END_POINTS.GET_PREVIOUS_ORDERS,
    method: "GET",
  });
};

export const getPreviousVoiceOrders = () => {
  return axios({
    url: ORDER_END_POINTS.GET_PREVIOUS_VOICE_ORDERS,
    method: "GET",
  });
};

export const createOrder = async (
  selectedDelivery,
  selectedBranchId,
  skus,
  bundles
) => {
  const data = {
    isCreatedFromMechanicWebsite: true,
    orderDetails: {
      ...selectedDelivery,
      deliveryDate: selectedDelivery.deliverySlotTo,
    },
    skuList: skus.map((sku) => ({
      skuId: sku.skuId,
      skuName: sku.name,
      quantity: sku.quantity,
    })),
    bundleList: bundles.map((bundle) => ({
      id: bundle.id,
      requestedQuantity: bundle.requestedQuantity,
    })),
  };
  if (selectedBranchId) {
    data.orderDetails.branchId = selectedBranchId;
  }
  return await axios({
    url: ORDER_END_POINTS.CREATE_ORDER,
    method: "POST",
    data: data,
  });
};

export const createVoiceOrder = (data) => {
  return axios({
    url: ORDER_END_POINTS.CREATE_VOICE_ORDER,
    method: "POST",
    data,
  });
};

export const checkMechanicHasPendingOrders = () => {
  return axios({
    url: ORDER_END_POINTS.CHECK_MECHANIC_HAS_PENDING_ORDERS,
    method: "GET",
  });
};

export const checkMechanicHasPricingDoneOrders = () => {
  return axios({
    url: ORDER_END_POINTS.CHECK_MECHANIC_HAS_PRICING_DONE_ORDERS,
    method: "GET",
  });
};

export const getPendingOrders = () => {
  return axios({
    url: ORDER_END_POINTS.GET_PENDING_ORDERS,
    method: "GET",
  });
};

export const getPricedOrders = () => {
  return axios({
    url: ORDER_END_POINTS.GET_PRICED_ORDERS,
    method: "GET",
  });
};

export const getPricedOrderItems = (orderId) => {
  return axios({
    url: ORDER_END_POINTS.GET_PRICED_ORDER_ITEMS.replace(":orderId", orderId),
    method: "GET",
  });
};

export const getOrderItemPrices = (itemId) => {
  return axios({
    url: ORDER_END_POINTS.GET_ORDER_ITEM_PRICES.replace(":itemId", itemId),
    method: "GET",
  });
};

export const acceptOrderPricing = (data) => {
  return axios({
    url: ORDER_END_POINTS.ACCEPT_ORDER_PRICING,
    method: "POST",
    data,
  });
};

export const rejectOrderPricing = (data) => {
  return axios({
    url: ORDER_END_POINTS.REJECT_ORDER_PRICING,
    method: "POST",
    data,
  });
};

export const getDeliverySlots = (data) => {
  return axios({
    url: ORDER_END_POINTS.GET_DELIVERY_SLOTS,
    method: "POST",
    data,
  });
};
